import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../../features/security/services/permission.service';

/**
 * ADM-003 : blocage APPLICATIF, jamais Cognito. `isActive=false` verrouille
 * la connexion pour TOUTE l'entreprise (verifie a l'audit) — incompatible
 * avec « l'utilisateur se connecte puis est redirige ». Ce garde laisse la
 * connexion intacte et force `/billing` tant qu'aucun abonnement utilisable
 * n'est en place.
 *
 * Memes regles que `TrialEnforcementGuard` cote serveur
 * (partners-service/src/common/guards/trial-enforcement.guard.ts) — jamais
 * inventees ici : `expired`/`canceled` bloquent toujours, `trialing` bloque
 * seulement si `trialEndsAt` est depasse, `past_due` ne bloque JAMAIS (etat
 * de grace deja documente ailleurs dans ce depot).
 */
export function estAbonnementBloque(
  status: string | null | undefined,
  trialEndsAt: string | null | undefined,
): boolean {
  if (status === 'expired' || status === 'canceled') return true;
  if (status === 'trialing' && trialEndsAt) {
    return new Date(trialEndsAt).getTime() < Date.now();
  }
  return false;
}

export const subscriptionGuard: CanActivateFn = () => {
  const router = inject(Router);
  const permissionService = inject(PermissionService);

  if (permissionService.isSuperAdmin()) {
    return true;
  }

  const status = localStorage.getItem('selectedCompanySubscriptionStatus');
  const trialEndsAt = localStorage.getItem('selectedCompanyTrialEndsAt');

  if (estAbonnementBloque(status, trialEndsAt)) {
    return router.createUrlTree(['/billing']);
  }

  return true;
};
